<div class="inner-card-section">
  <div class="d-flex inner-card-header">
    <h3 class="card-title">
      {{ 'calendar.createEvent' | translate }}
    </h3>
  </div>
  <form class="new-email d-flex flex-column" [formGroup]="form">
    <p class="rightHeadings">
      {{ 'shared.google.event.title' | translate }}
      <span class="text-danger">*</span>
    </p>
    <mat-form-field appearance="outline" class="w-100 small">
      <input formControlName="title" matInput matNativeControl [placeholder]="'shared.google.event.titlePlaceholder' | translate" />
    </mat-form-field>

    <p class="rightHeadings">
      {{ 'shared.google.event.description' | translate }}
    </p>
    <mat-form-field appearance="outline" class="w-100 small">
      <input formControlName="description" matInput [placeholder]="'shared.google.event.descriptionPlaceholder' | translate" />
    </mat-form-field>
    <div class="inner-card-section">
      <div class="inner-card-header">
        <h3 class="card-title">
          {{ 'dashboard.calendarTab.start' | translate }}
        </h3>
      </div>
      <div class="d-flex gap-1">
        <div class="d-flex flex-column">
          <p class="rightHeadings">
            {{ 'dashboard.calendarTab.hour' | translate }}
            <span class="text-danger">*</span>
          </p>
          <mat-form-field appearance="outline" class="w-100 small">
            <input matInput [ngxMatTimepicker]="pickerStart" [format]="24" autocomplete="off" formControlName="startT" />
          </mat-form-field>
          <ngx-mat-timepicker #pickerStart></ngx-mat-timepicker>
        </div>
        <div class="d-flex flex-column">
          <p class="rightHeadings">
            {{ 'dashboard.calendarTab.date' | translate }}
            <span class="text-danger">*</span>
          </p>
          <mat-form-field appearance="outline" class="w-100 small">
            <input [matDatepicker]="dpStart" matInput autocomplete="off" formControlName="startD" />
            <mat-datepicker-toggle [for]="dpStart" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #dpStart panelClass="example-month-picker"></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="inner-card-section">
      <div class="inner-card-header">
        <h3 class="card-title">
          {{ 'dashboard.calendarTab.end' | translate }}
        </h3>
      </div>
      <div class="d-flex gap-1">
        <div class="d-flex flex-column">
          <p class="rightHeadings">
            {{ 'dashboard.calendarTab.hour' | translate }}
            <span class="text-danger">*</span>
          </p>
          <mat-form-field appearance="outline" class="w-100 small">
            <input matInput [ngxMatTimepicker]="pickerEnd" [format]="24" autocomplete="off" formControlName="endT" />
          </mat-form-field>
          <ngx-mat-timepicker #pickerEnd></ngx-mat-timepicker>
        </div>
        <div class="d-flex flex-column">
          <p class="rightHeadings">
            {{ 'dashboard.calendarTab.date' | translate }}
            <span class="text-danger">*</span>
          </p>
          <mat-form-field appearance="outline" class="w-100 small">
            <input [matDatepicker]="dpEnd" matInput autocomplete="off" formControlName="endD" />
            <mat-datepicker-toggle [for]="dpEnd" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #dpEnd panelClass="example-month-picker"></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="d-flex">
      <button mat-flat-button class="p-btn-primary mt-3" type="button" (click)="createEvent()" [disabled]="!form.valid">
        {{ 'shared.google.event.create' | translate }}
      </button>
      <button mat-flat-button class="p-btn-light mt-3" type="button" (click)="cancel()">
        {{ 'shared.google.event.cancel' | translate }}
      </button>
    </div>
  </form>
</div>
